export default "__VITE_ASSET__Cg$RD$eQ__"